import React from 'react';
type StatusType = 'active' | 'inactive' | 'suspended' | 'pending' | 'completed' | 'cancelled' | 'resolved' | 'open' | 'in_progress' | 'online' | 'offline';
interface StatusBadgeProps {
  status: StatusType | string;
  className?: string;
}
export function StatusBadge({
  status,
  className = ''
}: StatusBadgeProps) {
  const getStatusStyles = (status: string) => {
    const s = status.toLowerCase();
    switch (s) {
      case 'active':
      case 'completed':
      case 'resolved':
      case 'verified':
      case 'online':
        return 'bg-green-100 text-green-700 border-green-200';
      case 'inactive':
      case 'offline':
        return 'bg-gray-100 text-gray-600 border-gray-200';
      case 'suspended':
      case 'cancelled':
      case 'blocked':
      case 'rejected':
      case 'high':
        return 'bg-red-100 text-red-700 border-red-200';
      case 'pending':
      case 'in_progress':
      case 'medium':
        return 'bg-yellow-100 text-yellow-700 border-yellow-200';
      case 'low':
      case 'open':
        return 'bg-blue-100 text-blue-700 border-blue-200';
      default:
        return 'bg-gray-100 text-gray-600 border-gray-200';
    }
  };
  const formatStatus = (status: string) => {
    return status.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  };
  return <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium border ${getStatusStyles(status)} ${className}`} data-id="element-100">
      {formatStatus(status)}
    </span>;
}